function escapeHTML(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }

  let cartPreviewTimer = null;
  let lastCartHash = null;
  let _binIdCounter = 0;


  function _binSvgHtml() {
    const uid = 'bin-mask-js-' + (++_binIdCounter);
    return `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 39 7" class="bin-top">
        <line stroke-width="4" stroke="white" y2="5" x2="39" y1="5"></line>
        <line stroke-width="3" stroke="white" y2="1.5" x2="26.0357" y1="1.5" x1="12"></line>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 33 39" class="bin-bottom">
        <mask fill="white" id="${uid}"><path d="M0 0H33V35C33 37.2091 31.2091 39 29 39H4C1.79086 39 0 37.2091 0 35V0Z"></path></mask>
        <path mask="url(#${uid})" fill="white" d="M0 0H33H0ZM37 35C37 39.4183 33.4183 43 29 43H4C-0.418278 43 -4 39.4183 -4 35H4H29H37ZM4 43C-0.418278 43 -4 39.4183 -4 35V0H4V35V43ZM37 0V35C37 39.4183 33.4183 43 29 43V35V0H37Z"></path>
        <path stroke-width="4" stroke="white" d="M12 6L12 29"></path>
        <path stroke-width="4" stroke="white" d="M21 6V29"></path>
      </svg>
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 89 80" class="garbage">
        <path fill="white" d="M20.5 10.5L37.5 15.5L42.5 11.5L51.5 12.5L68.75 0L72 11.5L79.5 12.5H88.5L87 22L68.75 31.5L75.5066 25L86 26L87 35.5L77.5 48L70.5 49.5L80 50L77.5 71.5L63.5 58.5L53.5 68.5L65.5 70.5L45.5 73L35.5 79.5L28 67L16 63L12 51.5L0 48L16 25L22.5 17L20.5 10.5Z"></path>
      </svg>`;
  }

  function refreshCartPreview(force = false) {

    if (Object.keys(_qtyPending).length > 0) return Promise.resolve();
    if (_qtyLocked && !force) return Promise.resolve();
    clearTimeout(cartPreviewTimer);
    cartPreviewTimer = setTimeout(() => _doRefreshCartPreview(force), 300);
  }

  async function _doRefreshCartPreview(force = false) {

    if (Object.keys(_qtyPending).length > 0) return;
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();


      if (Object.keys(_qtyPending).length > 0) return;


      const hash = JSON.stringify(cart.items.map(i => i.key + ':' + i.quantity)) + cart.total_price;


      if (!force && hash === lastCartHash) return;
      lastCartHash = hash;
      const itemsContainer = document.getElementById('CartDropdownItems');
      const footerContainer = document.getElementById('CartDropdownFooter');
      const badge = document.getElementById('CartCountBadge');

      if (badge) badge.innerText = cart.item_count > 0 ? cart.item_count : '';

      if (cart.item_count === 0) {
        itemsContainer.innerHTML = `
          <div class="cart-empty-state">
            <span class="cart-empty-state__icon">🛒</span>
            <span class="cart-empty-state__text">Coșul tău este gol</span>
            <span class="cart-empty-state__sub">Adaugă produse pentru a începe</span>
          </div>`;
        footerContainer.innerHTML = '';
        return;
      }

      const formatter = { format: (v) => v.toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Lei' };

      itemsContainer.innerHTML = cart.items.map(item => `
        <div class="cart-dropdown__item" data-key="${item.key}" data-unit-price="${item.price}">
          <a href="${item.url}"><img src="${item.image}" width="60" height="60" loading="lazy" decoding="async" alt="${escapeHTML(item.product_title || '')}" style="border-radius:8px; object-fit:cover;"></a>
          <div class="cart-dropdown__info">
            <a href="${item.url}" class="cart-dropdown__title-link">
              <span class="cart-dropdown__title">${escapeHTML(item.product_title)}</span>
            </a>
            <span class="cart-dropdown__price">${formatter.format(item.price * item.quantity / 100)}</span>
            <div class="cart-preview-qty">
              <button class="cart-preview-qty__btn" aria-label="Scade cantitatea" onclick="previewChangeQty('${item.key}', ${item.quantity - 1})"${item.quantity <= 1 ? ' disabled' : ''}>−</button>
              <span class="cart-preview-qty__num">${item.quantity}</span>
              <button class="cart-preview-qty__btn" aria-label="Crește cantitatea" onclick="previewChangeQty('${item.key}', ${item.quantity + 1})">+</button>
            </div>
          </div>
          <button class="cart-preview-remove" onclick="previewRemoveItem('${item.key}')" aria-label="Șterge">
            ${_binSvgHtml()}
          </button>
        </div>
      `).join('');

      // linkul „Drepturi privind garantia legala”: același marcaj ca în Liquid, luat din <template>-ul din sections/header.liquid
      const guaranteeNote = document.getElementById('AjLegalGuaranteeCartNote');

      footerContainer.innerHTML = `
        <div class="cart-dropdown__total" style="display:flex; justify-content:space-between; font-weight:900; font-size:16px; color:#333; margin-bottom:15px;">
          <span>Total:</span>
          <span class="cart-dropdown__total-value">${formatter.format(cart.total_price / 100)}</span>
        </div>
        <button onclick="openCartDrawerFromPreview()" class="cart-dropdown__btn" style="border:none; cursor:pointer; width:100%; margin-bottom:8px;">Vezi Coșul</button>
        <a href="/checkout" class="cart-dropdown__btn" style="background:#2ecc71; display:block; text-align:center;">Finalizează comanda</a>
        ${guaranteeNote ? guaranteeNote.innerHTML : ''}
      `;
    } catch (e) { console.error("Eroare update cos", e); }
  }

  function requestCartPreviewRefresh() {
    if (Object.keys(_qtyPending).length > 0 || _qtyLocked) return;
    refreshCartPreview();
  }

  document.addEventListener('cart:refresh', () => requestCartPreviewRefresh());


  window.wishlist = {
    data: JSON.parse(localStorage.getItem('wishlist_items')) || [],

    /* ── HTML comun pentru itemii din orice container ── */
    _buildItemsHTML() {
      if (this.data.length === 0) {
        return '<div class="wl-empty">Nu ai produse favorite.</div>';
      }
      return this.data.map(item => `
        <div class="cart-dropdown__item">
          <a href="${item.url}"><img src="${item.image}" width="60" height="60" loading="lazy" decoding="async" alt="${escapeHTML(item.title || '')}"></a>
          <div class="cart-dropdown__info">
            <a href="${item.url}" class="cart-dropdown__title-link">
              <span>${escapeHTML(item.title)}</span>
            </a>
            <span class="cart-dropdown__price">${item.price}</span>
          </div>
          <button onclick="wishlist.remove('${item.id}')" class="cart-preview-remove" aria-label="Șterge din favorite">
            ${_binSvgHtml()}
          </button>
        </div>
      `).join('');
    },

    updateUI() {
      const countLabel = document.getElementById('wishlist-count');
      if (countLabel) {
        if (this.data.length > 0) {
          countLabel.innerText = this.data.length;
          countLabel.style.display = 'flex';
        } else {
          countLabel.style.display = 'none';
        }
      }

      const html = this._buildItemsHTML();
      const dc = document.getElementById('wishlist-items-container');  // desktop
      const mc = document.getElementById('wishlist-mobile-items');     // mobile sheet
      if (dc) dc.innerHTML = html;
      if (mc) mc.innerHTML = html;

      this._syncCardButtons();
    },

    _syncCardButtons() {
      const wishlisted = new Set(this.data.map(i => String(i.id)));
      document.querySelectorAll('.wishlist-button-card').forEach(btn => {
        const btnId = btn.id.replace('wishlist-btn-', '');
        if (wishlisted.has(btnId)) {
          btn.classList.add('is-wishlisted');
          btn.setAttribute('aria-label', 'Elimină din favorite');
        } else {
          btn.classList.remove('is-wishlisted');
          btn.setAttribute('aria-label', 'Adaugă la favorite');
        }
      });
    },

    add(product) {
      if (!this.data.find(i => i.id === product.id)) {
        this.data.push(product);
        localStorage.setItem('wishlist_items', JSON.stringify(this.data));
        this.updateUI();
      }
    },

    remove(id) {
      this.data = this.data.filter(i => i.id !== id);
      localStorage.setItem('wishlist_items', JSON.stringify(this.data));
      this.updateUI();
    }
  };


  document.addEventListener('DOMContentLoaded', function() {

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const wrapper = document.getElementById('CartDropdownWrapper');
    const dropdown = document.getElementById('CartDropdownContent');
    let hideTimer = null;

    if (!isMobile) {
      wrapper.addEventListener('mouseenter', () => {
        clearTimeout(hideTimer);
        if (!lastCartHash && Object.keys(_qtyPending).length === 0) refreshCartPreview(true);
        dropdown.classList.add('is-open');
      });
      wrapper.addEventListener('mouseleave', () => {
        hideTimer = setTimeout(() => { dropdown.classList.remove('is-open'); }, 100);
      });
      dropdown.addEventListener('mouseenter', () => clearTimeout(hideTimer));
      dropdown.addEventListener('mouseleave', () => {
        hideTimer = setTimeout(() => { dropdown.classList.remove('is-open'); }, 100);
      });
    }


    // Foaia Favorite de pe telefon: fundalul blocat, focusul trece pe X,
    // Tab rămâne în foaie, iar la închidere focusul revine pe butonul care a deschis-o.
    function openSheet(sheet, overlay, closeBtn) {
      // Căutarea e mereu vizibilă pe telefon: sugestiile deschise nu rămân peste foaie.
      const openSuggestions = document.querySelector('#SearchSuggestions.is-active');
      if (openSuggestions) {
        openSuggestions.classList.remove('is-active');
        const input = document.getElementById('SearchInput');
        if (input) input.setAttribute('aria-expanded', 'false');
      }
      sheet._ajReturn = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      sheet.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      document.documentElement.classList.add('aj-drawer-locked');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    function closeSheet(sheet, overlay) {
      if (!sheet.classList.contains('is-open')) return;
      sheet.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.documentElement.classList.remove('aj-drawer-locked');
      const back = sheet._ajReturn;
      sheet._ajReturn = null;
      const active = document.activeElement;
      if (back && back.isConnected && (!active || active === document.body || sheet.contains(active))) {
        back.focus({ preventScroll: true });
      }
    }
    function trapSheetFocus(sheet) {
      sheet.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab' || !sheet.classList.contains('is-open')) return;
        const items = Array.from(sheet.querySelectorAll('a[href], button')).filter((el) => el.getClientRects().length);
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }

    const accountEnhancements = new WeakMap();
    const accountHoverMedia = window.matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)');
    const accountPageLocks = new WeakMap();
    const accountLockProperties = ['overflow', 'touch-action', 'scrollbar-gutter'];

    // On desktop the account panel is a header preview like Favorite and Cart:
    // Shopify's dialog opens non-modally, so the page keeps its scrollbar and
    // the other icons stay hoverable. Phones keep Shopify's modal sheet.
    function prepareAccountDialog(account) {
      const dialog = account.shadowRoot?.querySelector('dialog');
      if (!dialog) return false;
      if (dialog.showModal === HTMLDialogElement.prototype.showModal) {
        dialog.showModal = function() {
          if (!accountHoverMedia.matches) return HTMLDialogElement.prototype.showModal.call(this);
          const style = document.documentElement.style;
          accountPageLocks.set(account, accountLockProperties.map(name => [name, style.getPropertyValue(name), style.getPropertyPriority(name)]));
          return HTMLDialogElement.prototype.show.call(this);
        };
      }
      return true;
    }

    // Shopify locks <html> scrolling right after opening the dialog; undo it
    // in the same task, before the page renders without its scrollbar.
    function releaseAccountPageLock(account) {
      const saved = accountPageLocks.get(account);
      if (!saved) return;
      accountPageLocks.delete(account);
      const style = document.documentElement.style;
      saved.forEach(([name, value, priority]) => value ? style.setProperty(name, value, priority) : style.removeProperty(name));
    }

    function positionAccountDialog(account) {
      const dialog = account.shadowRoot?.querySelector('[part~="dialog"]');
      if (!dialog?.open) return;
      const desktop = window.matchMedia('(min-width: 769px)').matches;
      const trigger = account.closest(desktop ? '.aj-account' : '.aj-account__button') || account;
      const rect = trigger.getBoundingClientRect();
      // A non-modal dialog is positioned inside the account button, not the viewport.
      const origin = dialog.matches(':modal') ? { top: 0, left: 0 } : account.getBoundingClientRect();
      const reference = desktop ? account.closest('#HeaderWrapper')?.querySelector('.wishlist-preview-dropdown') : null;
      const referenceStyle = reference ? getComputedStyle(reference) : null;
      const gap = desktop ? parseFloat(referenceStyle?.marginTop) || 26 : 18;
      const top = `${Math.round(Math.max(0, rect.bottom + gap) - origin.top)}px`;
      if (account.style.getPropertyValue('--account-dialog-top') !== top) {
        account.style.setProperty('--account-dialog-top', top);
      }
      if (desktop) {
        const width = dialog.getBoundingClientRect().width;
        const viewport = Math.min(window.innerWidth, document.documentElement.clientWidth, document.body.clientWidth || window.innerWidth);
        // Same right alignment and spacing as the existing Favorite/Cart previews.
        const rightOffset = referenceStyle ? parseFloat(referenceStyle.right) || 0 : -20;
        const left = `${Math.round(Math.max(16, Math.min(rect.right - rightOffset - width, viewport - width - 16)) - origin.left)}px`;
        if (account.style.getPropertyValue('--aj-account-dialog-left') !== left) {
          account.style.setProperty('--aj-account-dialog-left', left);
        }
      } else {
        account.style.removeProperty('--aj-account-dialog-left');
      }
    }

    // Theme button styling for the account and login-form components (see snippets/aj-account.liquid).
    let accountShadowSheet = null;
    function styleAccountComponent(element) {
      if (typeof element?.appendSheets !== 'function') return;
      if (!accountShadowSheet) {
        const source = document.getElementById('AjAccountShadowStyles');
        if (!source || !('replaceSync' in CSSStyleSheet.prototype)) return;
        accountShadowSheet = new CSSStyleSheet();
        accountShadowSheet.replaceSync(source.content.textContent);
      }
      element.appendSheets(accountShadowSheet);
    }

    // Shopify's signed-in panel lists only the account menu (orders, profile): no sign-out. A quieter „Deconectare”
    // link goes under it while the component itself reports a signed-in customer, pointing to the theme's logout route
    // (data-aj-logout-url = routes.account_logout_url), Shopify's supported logout for new customer accounts.
    // It sits in .account__content, outside the header and menu regions that Shopify re-renders with innerHTML,
    // and is re-checked on every render while the panel is open.
    const ACCOUNT_SIGN_OUT_ICON = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M14.5 4.5H8.6a2.1 2.1 0 0 0-2.1 2.1v10.8a2.1 2.1 0 0 0 2.1 2.1h5.9"/><path d="M11.2 12h9.3"/><path d="M17 8.3 20.6 12 17 15.7"/></svg>';
    function syncAccountSignOut(account) {
      const content = account.shadowRoot?.querySelector('.account__content');
      if (!content) return;
      const host = account.closest('.aj-account');
      const url = host?.dataset.ajLogoutUrl;
      const signedIn = typeof account.getCustomer === 'function' && account.getCustomer() != null;
      let link = content.querySelector(':scope > .aj-account-signout');
      if (!signedIn || !url) {
        link?.remove();
        return;
      }
      if (link) return;
      link = document.createElement('a');
      link.className = 'aj-account-signout';
      link.href = url;
      link.target = '_top';
      link.innerHTML = ACCOUNT_SIGN_OUT_ICON;
      const label = document.createElement('span');
      label.textContent = host.dataset.ajLogoutLabel || 'Deconectare';
      link.append(label);
      content.append(link);
    }

    function stopAccountEnhancements(account) {
      const session = accountEnhancements.get(account);
      if (!session) return;
      session.observers.forEach(observer => observer.disconnect());
      session.root.removeEventListener('login-form:shop-login-loaded', session.schedule);
      session.root.removeEventListener('login-form:shop-user-matched', session.schedule);
      window.removeEventListener('resize', session.schedule);
      window.removeEventListener('scroll', session.schedule);
      session.header?.removeEventListener('transitionend', session.schedule);
      if (session.frame) cancelAnimationFrame(session.frame);
      accountEnhancements.delete(account);
    }

    function startAccountEnhancements(account) {
      stopAccountEnhancements(account);
      const root = account.shadowRoot;
      if (!root) return;
      const session = { root, header: account.closest('#HeaderWrapper'), observers: [], forms: new WeakSet(), expanded: new WeakSet(), frame: 0, schedule: null };

      function keepSignInChoicesVisible() {
        root.querySelectorAll('shopify-login-form').forEach(form => {
          const formRoot = form.shadowRoot;
          if (!formRoot) return;
          styleAccountComponent(form);
          if (!session.forms.has(form)) {
            session.forms.add(form);
            const observer = new MutationObserver(session.schedule);
            observer.observe(formRoot, { childList: true, subtree: true });
            session.observers.push(observer);
          }
          if (session.expanded.has(form)) return;
          const more = formRoot.querySelector('button.login-form__show-logins-button');
          if (!more || more.disabled || !more.getClientRects().length) return;
          let focused = document.activeElement;
          while (focused?.shadowRoot?.activeElement) focused = focused.shadowRoot.activeElement;
          session.expanded.add(form);
          more.click();
          if (focused instanceof HTMLElement && focused.isConnected) focused.focus({ preventScroll: true });
        });
      }

      session.schedule = function() {
        if (session.frame) return;
        session.frame = requestAnimationFrame(function() {
          session.frame = 0;
          if (!root.querySelector('[part~="dialog"]')?.open) return;
          syncAccountSignOut(account);
          keepSignInChoicesVisible();
          positionAccountDialog(account);
        });
      };
      accountEnhancements.set(account, session);
      const observer = new MutationObserver(session.schedule);
      observer.observe(root, { childList: true, subtree: true });
      session.observers.push(observer);
      const dialog = root.querySelector('[part~="dialog"]');
      if (dialog && 'ResizeObserver' in window) {
        const resize = new ResizeObserver(session.schedule);
        resize.observe(dialog);
        session.observers.push(resize);
      }
      root.addEventListener('login-form:shop-login-loaded', session.schedule);
      root.addEventListener('login-form:shop-user-matched', session.schedule);
      window.addEventListener('resize', session.schedule);
      window.addEventListener('scroll', session.schedule, { passive: true });
      session.header?.addEventListener('transitionend', session.schedule);
      styleAccountComponent(account);
      root.querySelectorAll('shopify-login-form').forEach(styleAccountComponent);
      syncAccountSignOut(account);
      positionAccountDialog(account);
      session.schedule();
    }

    document.addEventListener('open', function(event) {
      const account = event.target;
      if (!(account instanceof HTMLElement) || !account.matches('shopify-account')) return;
      releaseAccountPageLock(account);
      const suggestions = document.querySelector('#SearchSuggestions.is-active');
      if (suggestions) {
        suggestions.classList.remove('is-active');
        const input = document.getElementById('SearchInput');
        if (input) input.setAttribute('aria-expanded', 'false');
      }
      startAccountEnhancements(account);
    }, true);

    document.addEventListener('close', function(event) {
      const account = event.target;
      if (account instanceof HTMLElement && account.matches('shopify-account')) stopAccountEnhancements(account);
    }, true);

    document.querySelectorAll('shopify-account.aj-account__component').forEach(function(account) {
      const trigger = account.closest('.aj-account');
      if (!trigger) return;
      // Hover on .aj-account covers the icon and its panel (the dialog is in
      // its shadow tree), just like the Favorite and Cart wrappers.
      const otherPreviews = [document.getElementById('WishlistIconLink')?.closest('.wishlist-dropdown-wrapper'), document.getElementById('CartDropdownWrapper')].filter(Boolean);
      let pinned = false;
      let reopen = false;
      let skipAutoFocus = false;
      let waitingForRender = false;
      let hideTimer = 0;
      let watchedRoot = null;
      const getDialog = () => account.shadowRoot?.querySelector('dialog');
      const isPreviewOpen = () => {
        const dialog = getDialog();
        return !!dialog?.open && !dialog.matches(':modal') && !dialog.classList.contains('closing');
      };

      function closePreview() {
        clearTimeout(hideTimer);
        if (isPreviewOpen()) account.close();
      }

      function openPreview() {
        if (typeof account.showModal !== 'function') return;
        if (!prepareAccountDialog(account)) {
          // Shopify has not rendered the dialog yet: open once it has.
          if (!waitingForRender) {
            waitingForRender = true;
            document.addEventListener('shopify-render', function() {
              waitingForRender = false;
              if (trigger.matches(':hover') && !getDialog()?.open) openPreview();
            }, { once: true });
          }
          return;
        }
        pinned = false;
        // The browser and then Shopify (10 ms later) focus the dialog on opening;
        // a hover preview leaves focus alone.
        skipAutoFocus = document.activeElement !== account;
        const settle = () => {
          releaseAccountPageLock(account);
          setTimeout(() => { skipAutoFocus = false; }, 100);
        };
        Promise.resolve(account.showModal()).then(settle, settle);
      }

      function onDocumentPointerDown(event) {
        if (!event.composedPath().includes(trigger)) closePreview();
      }

      function onDocumentKeyDown(event) {
        if (event.key === 'Escape') closePreview();
      }

      // The orange ring marks keyboard focus on the icon itself, not on fields inside the panel.
      // Focus moving within the component only reaches its shadow root.
      let focusRoot = null;
      function syncIconFocus() {
        const active = account.shadowRoot?.activeElement;
        trigger.classList.toggle('is-icon-focused', !!active && active.matches('.account-button:focus-visible'));
      }
      function watchIconFocus() {
        const root = account.shadowRoot;
        if (!root || focusRoot === root) return;
        focusRoot = root;
        root.addEventListener('focusin', syncIconFocus);
        root.addEventListener('focusout', () => trigger.classList.remove('is-icon-focused'));
      }

      function onDialogClosed(event) {
        // Back on the icon while the panel was sliding out: show it again.
        if (event.target === getDialog() && reopen && trigger.matches(':hover')) openPreview();
        reopen = false;
      }

      trigger.addEventListener('pointerenter', function(event) {
        prepareAccountDialog(account);
        if (!accountHoverMedia.matches || event.pointerType === 'touch') return;
        clearTimeout(hideTimer);
        const dialog = getDialog();
        if (dialog?.classList.contains('closing')) {
          reopen = !event.composedPath().includes(dialog);
        } else if (!dialog?.open) {
          openPreview();
        }
      });
      trigger.addEventListener('pointerleave', function(event) {
        trigger.classList.remove('is-panel-hovered');
        if (event.pointerType === 'touch') return;
        reopen = false;
        if (pinned || !isPreviewOpen()) return;
        clearTimeout(hideTimer);
        hideTimer = setTimeout(closePreview, 100);
      });
      // The icon turns orange only while the pointer is on it, not on its panel.
      trigger.addEventListener('pointerover', function(event) {
        const dialog = getDialog();
        trigger.classList.toggle('is-panel-hovered', !!dialog && event.composedPath().includes(dialog));
      });
      // A click or typing keeps the panel open until Escape, X, a click
      // outside, focus leaving it or another header preview.
      trigger.addEventListener('pointerdown', function() {
        pinned = true;
        clearTimeout(hideTimer);
      });
      // A mouse click on the icon leaves no focus ring on it (the keyboard keeps one).
      trigger.addEventListener('mousedown', function(event) {
        if (event.composedPath().some(node => node instanceof Element && node.matches('.account-button'))) event.preventDefault();
      });
      trigger.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') return;
        pinned = true;
        clearTimeout(hideTimer);
      });
      trigger.addEventListener('focusin', function() {
        prepareAccountDialog(account);
        watchIconFocus();
        syncIconFocus();
        if (!skipAutoFocus || pinned) return;
        let focused = document.activeElement;
        while (focused?.shadowRoot?.activeElement) focused = focused.shadowRoot.activeElement;
        if (focused instanceof HTMLElement) focused.blur();
      });
      account.addEventListener('focusout', function(event) {
        if (event.relatedTarget && !trigger.contains(event.relatedTarget)) closePreview();
      });
      otherPreviews.forEach(function(preview) {
        preview.addEventListener('pointerenter', function(event) {
          if (event.pointerType !== 'touch') closePreview();
        });
      });
      account.addEventListener('open', function() {
        if (!isPreviewOpen()) return;
        document.addEventListener('pointerdown', onDocumentPointerDown, true);
        document.addEventListener('keydown', onDocumentKeyDown, true);
        if (account.shadowRoot && watchedRoot !== account.shadowRoot) {
          watchedRoot = account.shadowRoot;
          watchedRoot.addEventListener('close', onDialogClosed, true);
        }
      });
      account.addEventListener('close', function() {
        clearTimeout(hideTimer);
        pinned = false;
        skipAutoFocus = false;
        document.removeEventListener('pointerdown', onDocumentPointerDown, true);
        document.removeEventListener('keydown', onDocumentKeyDown, true);
      });
      accountHoverMedia.addEventListener('change', function() {
        if (!accountHoverMedia.matches) closePreview();
      });
    });

    // ── Wishlist Mobile Sheet ─────────────────────────────────────────
    const wlIconLink = document.getElementById('WishlistIconLink');
    const wlSheet    = document.getElementById('WishlistMobileSheet');
    const wlOverlay  = document.getElementById('WishlistMobileOverlay');
    const wlClose    = document.getElementById('WishlistMobileClose');

    if (wlSheet && wlIconLink) {
      function openWlSheet() {
        wishlist.updateUI();
        openSheet(wlSheet, wlOverlay, wlClose);
        history.pushState({ ajWishlist: true }, '');
      }
      function closeWlSheet() {
        closeSheet(wlSheet, wlOverlay);
      }
      trapSheetFocus(wlSheet);

      wlIconLink.addEventListener('click', function(e) {
        if (window.innerWidth > 768) return;  // desktop folosește hover
        e.preventDefault();
        wlSheet.classList.contains('is-open') ? closeWlSheet() : openWlSheet();
      });

      if (wlOverlay) wlOverlay.addEventListener('click', closeWlSheet);
      if (wlClose)   wlClose.addEventListener('click', closeWlSheet);

      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && wlSheet.classList.contains('is-open')) closeWlSheet();
      });
      window.addEventListener('popstate', function() {
        if (wlSheet.classList.contains('is-open')) closeWlSheet();
      });
    }


    const searchInput = document.getElementById('SearchInput');
    const suggestions = document.getElementById('SearchSuggestions');
    const headerWrapper = document.getElementById('HeaderWrapper');
    const spacer = document.querySelector('.header-spacer');
    const burgerScrolled = document.getElementById('BurgerScrolled');
    const headerNavRow = document.getElementById('HeaderNavRow');

    // Mobile drawer
    const mobileDrawer = document.getElementById('AjMobileDrawer');
    const mobileOverlay = document.getElementById('AjMobileOverlay');
    // Move out of Shopify section stacking context so z-index applies globally
    if (mobileDrawer) document.body.appendChild(mobileDrawer);
    if (mobileOverlay) document.body.appendChild(mobileOverlay);
    const drawerCloseBtn = document.getElementById('AjMobileDrawerClose');
    // Focusul: la deschidere trece pe butonul de închidere, Tab rămâne în meniu, la închidere revine pe hamburger.
    let drawerReturnFocus = null;
    function openMobileDrawer() {
      if (!mobileDrawer) return;
      drawerReturnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : null;
      mobileDrawer.classList.add('is-open');
      mobileDrawer.removeAttribute('aria-hidden');
      mobileDrawer.removeAttribute('inert');
      if (mobileOverlay) mobileOverlay.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      // fundalul rămâne blocat și pe iOS (overflow doar pe body nu ajunge acolo)
      document.documentElement.classList.add('aj-drawer-locked');
      if (drawerCloseBtn) drawerCloseBtn.focus({ preventScroll: true });
      // History state so Back button closes drawer first
      if (!history.state || !history.state.ajDrawer) {
        history.pushState({ ajDrawer: true }, '');
      }
    }
    function closeMobileDrawer() {
      if (!mobileDrawer) return;
      mobileDrawer.classList.remove('is-open');
      mobileDrawer.setAttribute('aria-hidden', 'true');
      mobileDrawer.setAttribute('inert', '');
      if (mobileOverlay) mobileOverlay.classList.remove('is-open');
      document.body.style.overflow = '';
      document.documentElement.classList.remove('aj-drawer-locked');
      const back = drawerReturnFocus;
      drawerReturnFocus = null;
      if (back && back.isConnected && (!document.activeElement || document.activeElement === document.body || mobileDrawer.contains(document.activeElement))) {
        back.focus({ preventScroll: true });
      }
    }
    if (mobileDrawer) {
      mobileDrawer.addEventListener('keydown', function(e) {
        if (e.key !== 'Tab' || !mobileDrawer.classList.contains('is-open')) return;
        const items = Array.from(mobileDrawer.querySelectorAll('a[href], button, summary'))
          .filter((el) => el.getClientRects().length && !el.closest('[inert]'));
        if (!items.length) return;
        const first = items[0];
        const last = items[items.length - 1];
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      });
    }
    if (drawerCloseBtn) drawerCloseBtn.addEventListener('click', closeMobileDrawer);
    if (mobileOverlay) {
      mobileOverlay.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        closeMobileDrawer();
      });
    }
    // Capture-phase global listener — robust click-outside regardless of overlay behavior
    document.addEventListener('click', function(e) {
      if (!mobileDrawer || !mobileDrawer.classList.contains('is-open')) return;
      if (mobileDrawer.contains(e.target)) return;
      e.preventDefault();
      e.stopPropagation();
      closeMobileDrawer();
    }, true);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && mobileDrawer && mobileDrawer.classList.contains('is-open')) closeMobileDrawer();
    });

    function isMobileView() { return window.matchMedia('(max-width: 768px)').matches; }

    // ── Back button behavior (mobile only) ───────────────────────
    // Căutarea rămâne vizibilă. Prioritate: sugestii → meniu → navigare.
    window.addEventListener('popstate', function(e) {
      if (!isMobileView()) return;

      // 1. Close suggestions if open
      if (suggestions && suggestions.classList.contains('is-active')) {
        suggestions.classList.remove('is-active');
        if (searchInput) searchInput.setAttribute('aria-expanded', 'false');
        return;
      }

      // 2. Close drawer if open
      if (mobileDrawer && mobileDrawer.classList.contains('is-open')) {
        closeMobileDrawer();
        return;
      }

      // 3. Normal navigation — let browser proceed
    });

    // When user actually touches/clicks the input on mobile → push history for Back button
    if (searchInput) {
      searchInput.addEventListener('focus', function() {
        if (isMobileView() && suggestions && !suggestions.classList.contains('is-active')) {
          // Push state so Back can close suggestions (o singură intrare: câmpul e mereu vizibil și se atinge des)
          if (!history.state || !history.state.ajSuggestions) history.pushState({ ajSuggestions: true }, '');
        }
      });
    }

    // ── Mobile theme proxy ────────────────────────────────────────
    const mobileThemeBtn = document.getElementById('MobileThemeBtn');
    if (mobileThemeBtn) {
      mobileThemeBtn.addEventListener('click', function() {
        const slider = document.getElementById('AjThemeSlider');
        if (slider) slider.click();
      });
    }

    wishlist.updateUI();

    const cartIconBubble = document.getElementById('cart-icon-bubble');
    if (cartIconBubble) {
      new MutationObserver(() => requestCartPreviewRefresh()).observe(cartIconBubble, {
        childList: true,
        subtree: false
      });
    }



    const COMPACT_HEADER_AT = 250;
    const EXPAND_HEADER_AT = 50;
    // Desktop: #MainContent rezervă sus înălțimea headerului COMPLET, iar cel compact e mult mai scund. La urcare,
    // cu doar pragul de 50px, bannerul ieșea de sub headerul compact înainte de revenire și rămânea o bandă goală
    // între val și banner. Headerul complet revine cu EXPAND_HEADER_LEAD px înainte ca bannerul să se desprindă;
    // EXPAND_HEADER_MAX păstrează distanța față de COMPACT_HEADER_AT, deci fără comutări repetate. Telefonul nu se schimbă.
    const EXPAND_HEADER_LEAD = 24;
    const EXPAND_HEADER_MAX = COMPACT_HEADER_AT - 40;
    const mainContent = document.getElementById('MainContent');
    function contentLeavesCompactHeader() {
      if (!mainContent || !headerWrapper.classList.contains('is-scrolled') || isMobileView() || window.scrollY >= EXPAND_HEADER_MAX) return false;
      const contentTop = mainContent.getBoundingClientRect().top + parseFloat(getComputedStyle(mainContent).paddingTop);
      return contentTop > headerWrapper.getBoundingClientRect().bottom - EXPAND_HEADER_LEAD;
    }

    // Desktop: valul vizibil de sub header e #MainContent::before (CSS în sections/header.liquid), lipit cu position: sticky
    // la max(baza headerului, începutul conținutului). Browserul îl așază în același cadru cu derularea, deci bannerul nu se
    // desprinde de val nici la urcare rapidă, nici la oprire bruscă, nici în tranziția de 0,3s a headerului. Scriptul doar
    // mută pragul lipirii (top = baza headerului − 2px) când headerul își schimbă înălțimea, cadru cu cadru cât durează
    // tranziția, și trece pe valul propriu al headerului (.aj-wave-in-header) spre finalul conținutului, unde ::before
    // nu mai poate rămâne lipit. Pragul e o regulă CSS proprie, ca schimbarea lui să nu recalculeze stilul întregii pagini.
    // Bucla ține cel puțin WAVE_SETTLE_MS după fiecare derulare sau comutare: în primul cadru al tranziției headerul are
    // încă înălțimea de start, iar o oprire acolo lăsa pragul blocat (valul ascuns sub headerul complet, sau coborât
    // sub cel compact cu o bandă goală deasupra) până la următoarea derulare. Telefonul nu se schimbă.
    const WAVE_HEADER_NEAR_END = 300;
    const WAVE_SETTLE_MS = 500;
    let waveTopRule = null;
    let waveFrame = 0;
    let waveSettleUntil = 0;
    let lastHeaderBottom = -1;
    function syncWave() {
      waveFrame = 0;
      if (!mainContent || isMobileView()) {
        lastHeaderBottom = -1;
        return;
      }
      const bottom = headerWrapper.getBoundingClientRect().bottom;
      if (bottom !== lastHeaderBottom) {
        if (!waveTopRule) {
          const style = document.createElement('style');
          style.textContent = '@media (min-width: 769px) { body #MainContent::before {} }';
          document.head.appendChild(style);
          waveTopRule = style.sheet.cssRules[0].cssRules[0];
        }
        waveTopRule.style.setProperty('top', (bottom - 2) + 'px');
      }
      if (bottom !== lastHeaderBottom || performance.now() < waveSettleUntil) waveFrame = requestAnimationFrame(syncWave);
      lastHeaderBottom = bottom;
      headerWrapper.classList.toggle('aj-wave-in-header', mainContent.getBoundingClientRect().bottom - bottom < WAVE_HEADER_NEAR_END);
    }
    function followWave() {
      waveSettleUntil = performance.now() + WAVE_SETTLE_MS;
      cancelAnimationFrame(waveFrame);
      syncWave();
    }
    followWave();
    // După fonturi și imagini headerul poate avea altă înălțime; la finalul oricărei tranziții din header, ultima verificare.
    window.addEventListener('load', followWave);
    headerWrapper.addEventListener('transitionend', followWave);
    let waveResizeTimer = 0;
    window.addEventListener('resize', () => {
      clearTimeout(waveResizeTimer);
      // După syncHeaderPadding din layout/theme.liquid (150ms).
      waveResizeTimer = setTimeout(followWave, 250);
    }, { passive: true });


    let userHasScrolled = false;
    let scrollTicking = false;
    window.addEventListener('scroll', () => {

      if (!userHasScrolled && performance.now() < 1500) return;
      userHasScrolled = true;
      if (!scrollTicking) {
        requestAnimationFrame(() => {
          if (window.scrollY > COMPACT_HEADER_AT) {
            if (!headerWrapper.classList.contains('is-scrolled')) {
              headerWrapper.classList.add('is-scrolled');
            }
          } else if (window.scrollY < EXPAND_HEADER_AT || contentLeavesCompactHeader()) {
            if (headerWrapper.classList.contains('is-scrolled')) {
              headerWrapper.classList.remove('is-scrolled');
              headerNavRow.classList.remove('is-open');
              burgerScrolled.classList.remove('is-active');
              burgerScrolled.setAttribute('aria-expanded', 'false');
              if (burgerInSearch) {
                burgerInSearch.classList.remove('is-active');
                burgerInSearch.setAttribute('aria-expanded', 'false');
              }
            }
          }
          followWave();
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    }, { passive: true });

    burgerScrolled.addEventListener('click', function() {
      if (window.matchMedia('(max-width: 768px)').matches) {
        openMobileDrawer();
      } else {
        const isOpen = this.classList.toggle('is-active');
        headerNavRow.classList.toggle('is-open');
        this.setAttribute('aria-expanded', String(isOpen));
        if (burgerInSearch) {
          burgerInSearch.classList.toggle('is-active', isOpen);
          burgerInSearch.setAttribute('aria-expanded', String(isOpen));
        }
      }
    });


    const burgerInSearch = document.getElementById('BurgerInSearch');
    if (burgerInSearch) {
      burgerInSearch.addEventListener('click', function() {
        const isOpen = headerNavRow.classList.toggle('is-open');
        this.classList.toggle('is-active', isOpen);
        this.setAttribute('aria-expanded', String(isOpen));
        burgerScrolled.classList.toggle('is-active', isOpen);
        burgerScrolled.setAttribute('aria-expanded', String(isOpen));
      });
    }

    // Mega-menu-urile din navigație: controllerul e la finalul fișierului (initMegaMenus).

    if (searchInput && suggestions) {
      const searchDefaults = document.getElementById('SearchDefaults');
      const searchLiveResults = document.getElementById('SearchLiveResults');
      let searchTimer = null;

      searchInput.addEventListener('focus', function() {
        suggestions.classList.add('is-active');
        searchInput.setAttribute('aria-expanded', 'true');
      });


      searchInput.addEventListener('input', function() {
        const query = this.value.trim();
        clearTimeout(searchTimer);

        if (query.length < 2) {

          searchDefaults.style.display = '';
          searchLiveResults.style.display = 'none';
          searchLiveResults.innerHTML = '';
          return;
        }


        searchTimer = setTimeout(() => {
          searchDefaults.style.display = 'none';
          searchLiveResults.style.display = 'block';
          searchLiveResults.innerHTML = '<div class="suggestion-loading">Se caută...</div>';

          // resources[options][fields]: implicit Shopify NU caută în variants.sku — îl
          // includem explicit (plus barcode/body) ca SKU-urile gen AJ-000043 să fie găsite.
          fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&resources[options][fields]=title,product_type,variants.title,variants.sku,variants.barcode,vendor,tag,body`)
            .then(r => r.json())
            .then(data => {
              const products = data.resources?.results?.products || [];

              if (products.length === 0) {
                searchLiveResults.innerHTML = '<div class="suggestion-no-results">Niciun produs găsit pentru „' + escapeHTML(query) + '"</div>';
                return;
              }

              searchLiveResults.innerHTML =
                '<span class="suggestion-title">Rezultate pentru „' + escapeHTML(query) + '"</span>' +
                products.map(p => {

                  const price = parseFloat(p.price).toLocaleString('ro-RO', { minimumFractionDigits: 2 }) + ' Lei';
                  return `
                  <a href="${p.url}" class="suggestion-item">
                    <img src="${p.image || p.featured_image?.url || ''}" class="suggestion-image" width="50" height="50" loading="lazy" decoding="async" alt="${escapeHTML(p.title)}">
                    <div class="suggestion-info">
                      <span class="suggestion-name">${escapeHTML(p.title)}</span>
                      <span class="suggestion-price">${price}</span>
                    </div>
                  </a>
                `}).join('') +
                `<a href="/search?q=${encodeURIComponent(query)}" class="suggestion-view-all">Vezi toate rezultatele →</a>`;
            })
            .catch(() => {
              searchLiveResults.innerHTML = '<div class="suggestion-no-results">Eroare la căutare. Încearcă din nou.</div>';
            });
        }, 300);
      });

      document.addEventListener('click', function(e) {
        if (!searchInput.contains(e.target) && !suggestions.contains(e.target)) {
          suggestions.classList.remove('is-active');
          searchInput.setAttribute('aria-expanded', 'false');
        }
      });
    }
  });

  function openCartDrawerFromPreview() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      cartDrawer.open();
    }
  }

  async function _cartChange(key, quantity, skipPreviewRefresh = false) {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: ['cart-drawer', 'cart-icon-bubble'] })
    });
    const parsedState = await response.json();

    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && parsedState.sections) {
      cartDrawer.getSectionsToRender().forEach((section) => {
        const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
        if (!el) return;
        el.innerHTML = cartDrawer.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      });
      if (parsedState.item_count === 0) {
        cartDrawer.classList.add('is-empty');
      } else {
        cartDrawer.classList.remove('is-empty');
      }
      const overlay = document.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', () => cartDrawer.close());
    }
    if (!skipPreviewRefresh) await refreshCartPreview(true);
    return parsedState;
  }

  async function previewRemoveItem(key) {
    try { await _cartChange(key, 0); }
    catch(e) { console.error('Remove error', e); }
  }


  const _qtyDebounceTimers = {};

  const _qtyPending = {};

  let _qtyLocked = false;


  function _patchCartPreviewFromServer() {
    return fetch('/cart.js').then(r => r.json()).then(cart => {

      if (Object.keys(_qtyPending).length > 0) return;
      const badge = document.getElementById('CartCountBadge');
      if (badge) badge.innerText = cart.item_count > 0 ? cart.item_count : '';

      const itemsContainer = document.getElementById('CartDropdownItems');
      const footerContainer = document.getElementById('CartDropdownFooter');

      if (cart.item_count === 0) {
        itemsContainer.innerHTML = `
          <div class="cart-empty-state">
            <span class="cart-empty-state__icon">🛒</span>
            <span class="cart-empty-state__text">Coșul tău este gol</span>
            <span class="cart-empty-state__sub">Adaugă produse pentru a începe</span>
          </div>`;
        footerContainer.innerHTML = '';
        lastCartHash = null;
        return;
      }


      const serverKeys = new Set(cart.items.map(i => i.key));
      const domItems = itemsContainer.querySelectorAll('.cart-dropdown__item[data-key]');
      const domKeys = new Set();

      domItems.forEach(el => {
        const key = el.dataset.key;
        domKeys.add(key);
        const serverItem = cart.items.find(i => i.key === key);
        if (!serverItem) {

          el.remove();
          return;
        }

        const num = el.querySelector('.cart-preview-qty__num');
        if (num && parseInt(num.textContent) !== serverItem.quantity) {
          num.textContent = serverItem.quantity;

          num.classList.remove('is-animating');
          void num.offsetWidth;
          num.classList.add('is-animating');
          num.addEventListener('animationend', () => num.classList.remove('is-animating'), { once: true });
        }

        const priceEl = el.querySelector('.cart-dropdown__price');
        if (priceEl) {
          priceEl.textContent = (serverItem.price * serverItem.quantity / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Lei';
        }

        const btns = el.querySelectorAll('.cart-preview-qty__btn');
        if (btns.length === 2) {
          btns[0].setAttribute('onclick', `previewChangeQty('${key}', ${serverItem.quantity - 1})`);
          btns[1].setAttribute('onclick', `previewChangeQty('${key}', ${serverItem.quantity + 1})`);
        }
      });


      let hasNewItems = false;
      serverKeys.forEach(k => { if (!domKeys.has(k)) hasNewItems = true; });
      if (hasNewItems) {
        lastCartHash = null;
        refreshCartPreview(true);
        return;
      }


      const totalEl = document.querySelector('#CartDropdownFooter .cart-dropdown__total-value');
      if (totalEl) {
        totalEl.textContent = (cart.total_price / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Lei';
      }


      lastCartHash = JSON.stringify(cart.items.map(i => i.key + ':' + i.quantity)) + cart.total_price;
    }).catch(e => console.error('Patch error', e));
  }

  async function previewChangeQty(key, newQty) {
    if (newQty < 1) return;


    _qtyPending[key] = newQty;
    _qtyLocked = true;

    const itemEl = document.querySelector(`.cart-dropdown__item[data-key="${key}"]`);
    if (itemEl) {

      const num = itemEl.querySelector('.cart-preview-qty__num');
      if (num) {
        num.textContent = newQty;
        num.classList.remove('is-animating');
        void num.offsetWidth;
        num.classList.add('is-animating');
        num.addEventListener('animationend', () => num.classList.remove('is-animating'), { once: true });
      }

      const priceEl = itemEl.querySelector('.cart-dropdown__price');
      if (priceEl && itemEl.dataset.unitPrice) {
        const unitPrice = parseFloat(itemEl.dataset.unitPrice);
        priceEl.textContent = (unitPrice * newQty / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Lei';
      }

      const totalEl = document.querySelector('#CartDropdownFooter .cart-dropdown__total-value');
      if (totalEl) {
        let cartTotal = 0;
        document.querySelectorAll('.cart-dropdown__item').forEach(el => {
          const qty = parseInt(el.querySelector('.cart-preview-qty__num')?.textContent || 0);
          const up = parseFloat(el.dataset.unitPrice || 0);
          cartTotal += qty * up;
        });
        totalEl.textContent = (cartTotal / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' Lei';
      }

      const btns = itemEl.querySelectorAll('.cart-preview-qty__btn');
      if (btns.length === 2) {
        btns[0].setAttribute('onclick', `previewChangeQty('${key}', ${newQty - 1})`);
        btns[1].setAttribute('onclick', `previewChangeQty('${key}', ${newQty + 1})`);
        btns[0].disabled = newQty <= 1;
      }
    }


    clearTimeout(_qtyDebounceTimers[key]);
    _qtyDebounceTimers[key] = setTimeout(async () => {
      const finalQty = _qtyPending[key];
      delete _qtyPending[key];
      delete _qtyDebounceTimers[key];

      try {
        lastCartHash = null;

        const parsedState = await _cartChange(key, finalQty, true);



        if (!parsedState.items) {

          await _patchCartPreviewFromServer();
        } else {

          const serverItem = parsedState.items.find(i => i.key === key);
          if (serverItem && serverItem.quantity !== finalQty) {

            await _patchCartPreviewFromServer();
          }
        }
      } catch(e) {
        console.error('Qty change error', e);

        await _patchCartPreviewFromServer();
      }
      finally {

        if (Object.keys(_qtyPending).length === 0) {
          _qtyLocked = false;
        }
      }
    }, 400);
  }

  /* ── Mega-menu-uri desktop (≥769px) ─────────────────────────────
     Butoanele [data-aj-mega-trigger] din #HeaderNavRow deschid panourile .aj-mega din [data-aj-megas]
     (snippets/aj-mega-menu.liquid). Poziția e pur CSS (sub header și sub val); aici e doar starea:
     hover cu intenție (mouse), click/Enter/Space, ArrowDown, Tab în panou și înapoi, Escape, click sau focus
     în exterior, schimbarea între meniuri și închiderea la headerul compact / sub 769px.
     Fără requestAnimationFrame și fără măsurători de layout. */
  (function initMegaMenus() {
    const OPEN_DELAY = 80;
    // Fără punte sub butoane: spațiul de ~20px până la panou e acoperit de CLOSE_DELAY, iar o diagonală spre
    // marginea panoului care atinge doar colțul unui buton vecin nu schimbă meniul.
    const SWITCH_DELAY = 120;
    const CLOSE_DELAY = 300;
    // Mouse pe un buton fără meniu (Toate produsele, Contact): meniul deschis se închide aproape imediat.
    const PLAIN_ITEM_CLOSE_DELAY = 90;
    const CLICK_GRACE = 450;
    const FADE_OUT = 260;
    const FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
    const desktop = window.matchMedia('(min-width: 769px)');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function setup(navRow) {
      if (navRow.ajMegaMenus) return;
      const wrapper = navRow.closest('#HeaderWrapper');
      const layer = navRow.querySelector('[data-aj-megas]');
      if (!wrapper || !layer) return;
      const entries = [...navRow.querySelectorAll('[data-aj-mega-trigger]')]
        .map((trigger) => ({ trigger, item: trigger.closest('li'), panel: document.getElementById(trigger.getAttribute('aria-controls')) }))
        .filter((entry) => entry.item && entry.panel && layer.contains(entry.panel));
      if (!entries.length) return;

      const controller = new AbortController();
      const signal = controller.signal;
      let current = null;
      let hoverOpenedAt = -Infinity;
      let openTimer = 0;
      let closeTimer = 0;
      let switchTimer = 0;
      let settleTimer = 0;
      let switchEndTimer = 0;
      let compact = wrapper.classList.contains('is-scrolled');

      const inRegion = (node) => node instanceof Node && entries.some((entry) => entry.item.contains(node) || entry.panel.contains(node));
      const hovered = () => entries.some((entry) => entry.item.matches(':hover') || entry.panel.matches(':hover'));
      const focusables = (root) => [...root.querySelectorAll(FOCUSABLE)].filter((element) => element.getClientRects().length > 0);
      const cancelPending = () => {
        clearTimeout(openTimer);
        clearTimeout(closeTimer);
        clearTimeout(switchTimer);
      };

      // Imagini amânate din panou (img[data-src]): src se setează o singură dată, la prima intenție pe buton
      // (pointerenter / focus), înainte de deschidere; show() acoperă orice altă cale de deschidere. Doar pe desktop.
      const loadDeferred = (entry) => {
        if (!desktop.matches) return;
        entry.panel.querySelectorAll('img[data-src]').forEach((img) => {
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
        });
      };

      function show(entry, { viaHover = false } = {}) {
        loadDeferred(entry);
        cancelPending();
        if (!desktop.matches || current === entry) return;
        // În headerul compact rândul de navigație e doar ascuns (opacity 0) până e deschis din burger.
        if (wrapper.classList.contains('is-scrolled') && !navRow.classList.contains('is-open')) return;
        const previous = current;
        clearTimeout(settleTimer);
        clearTimeout(switchEndTimer);
        layer.classList.remove('aj-megas--instant');
        layer.classList.toggle('is-switching', Boolean(previous));
        if (previous) {
          previous.panel.classList.remove('is-open');
          previous.trigger.setAttribute('aria-expanded', 'false');
          switchEndTimer = setTimeout(() => layer.classList.remove('is-switching'), FADE_OUT);
        }
        current = entry;
        hoverOpenedAt = viaHover ? performance.now() : -Infinity;
        wrapper.classList.add('aj-mega-active');
        entry.panel.classList.add('is-open');
        entry.trigger.setAttribute('aria-expanded', 'true');
      }

      function hide({ instant = false, focusTrigger = false } = {}) {
        cancelPending();
        if (!current) return;
        const entry = current;
        const hadFocus = entry.panel.contains(document.activeElement);
        current = null;
        clearTimeout(switchEndTimer);
        layer.classList.remove('is-switching');
        layer.classList.toggle('aj-megas--instant', instant);
        entry.panel.classList.remove('is-open');
        entry.trigger.setAttribute('aria-expanded', 'false');
        if (focusTrigger && hadFocus) entry.trigger.focus({ preventScroll: true });
        clearTimeout(settleTimer);
        const settle = () => {
          if (!current) wrapper.classList.remove('aj-mega-active');
        };
        if (instant || reducedMotion.matches) settle();
        else settleTimer = setTimeout(settle, FADE_OUT);
      }

      function scheduleClose(event) {
        if (!current || inRegion(event.relatedTarget)) return;
        // Navigarea cu tastatura în panou are prioritate: mouse-ul care iese nu închide meniul.
        const focused = document.activeElement;
        if (current.panel.contains(focused) && focused.matches(':focus-visible')) return;
        clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          if (!hovered()) hide();
        }, CLOSE_DELAY);
      }

      function focusFirst(entry) {
        const first = focusables(entry.panel)[0];
        if (!first) return false;
        first.focus({ preventScroll: true });
        return true;
      }

      function nextNavFocusable(entry) {
        for (let item = entry.item.nextElementSibling; item; item = item.nextElementSibling) {
          const element = focusables(item)[0];
          if (element) return element;
        }
        return null;
      }

      navRow.querySelectorAll('.list-menu--inline > li').forEach((item) => {
        if (entries.some((entry) => entry.item === item)) return;
        item.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !current) return;
          cancelPending();
          closeTimer = setTimeout(() => {
            if (!entries.some((entry) => entry.item.matches(':hover') || entry.panel.matches(':hover'))) hide();
          }, PLAIN_ITEM_CLOSE_DELAY);
        }, { signal });
      });

      entries.forEach((entry) => {
        entry.item.addEventListener('pointerenter', () => loadDeferred(entry), { signal });
        entry.trigger.addEventListener('focus', () => loadDeferred(entry), { signal });
        entry.item.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse' || !desktop.matches) return;
          cancelPending();
          if (current === entry) return;
          if (current) switchTimer = setTimeout(() => show(entry, { viaHover: true }), SWITCH_DELAY);
          else openTimer = setTimeout(() => show(entry, { viaHover: true }), OPEN_DELAY);
        }, { signal });
        entry.item.addEventListener('pointerleave', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(openTimer);
          clearTimeout(switchTimer);
          scheduleClose(event);
        }, { signal });
        entry.panel.addEventListener('pointerenter', (event) => {
          if (event.pointerType !== 'mouse') return;
          clearTimeout(closeTimer);
          clearTimeout(switchTimer);
        }, { signal });
        entry.panel.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'mouse') scheduleClose(event);
        }, { signal });

        entry.trigger.addEventListener('click', (event) => {
          if (current !== entry) {
            show(entry);
            return;
          }
          // Clickul venit imediat după deschiderea prin hover confirmă meniul, nu îl închide.
          if (event.detail > 0 && performance.now() - hoverOpenedAt < CLICK_GRACE) return;
          hide();
        }, { signal });

        entry.trigger.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowDown') {
            event.preventDefault();
            show(entry);
            focusFirst(entry);
          } else if (event.key === 'Tab' && !event.shiftKey && current === entry && focusFirst(entry)) {
            // Panoul stă după toate butoanele în DOM: Tab de pe butonul deschis intră direct în el.
            event.preventDefault();
          }
        }, { signal });

        entry.panel.addEventListener('keydown', (event) => {
          if (event.key !== 'Tab') return;
          const items = focusables(entry.panel);
          if (!items.length) return;
          if (event.shiftKey && document.activeElement === items[0]) {
            event.preventDefault();
            entry.trigger.focus();
          } else if (!event.shiftKey && document.activeElement === items[items.length - 1]) {
            const next = nextNavFocusable(entry);
            if (!next) return;
            event.preventDefault();
            hide();
            next.focus();
          }
        }, { signal });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && current) hide({ focusTrigger: true });
      }, { signal });
      document.addEventListener('click', (event) => {
        if (current && !inRegion(event.target)) hide();
      }, { capture: true, signal });
      document.addEventListener('focusin', (event) => {
        if (current && !inRegion(event.target)) hide();
      }, { signal });
      desktop.addEventListener('change', () => {
        if (!desktop.matches) hide({ instant: true });
      }, { signal });

      // Header compact (.is-scrolled, din handlerul de scroll) sau rândul de navigație compact închis: fără panou rămas.
      const observer = new MutationObserver(() => {
        const nowCompact = wrapper.classList.contains('is-scrolled');
        if (nowCompact !== compact) {
          compact = nowCompact;
          hide({ instant: true });
        } else if (compact && !navRow.classList.contains('is-open')) {
          hide({ instant: true });
        }
      });
      observer.observe(wrapper, { attributes: true, attributeFilter: ['class'] });
      observer.observe(navRow, { attributes: true, attributeFilter: ['class'] });

      function destroy() {
        hide({ instant: true });
        controller.abort();
        observer.disconnect();
        clearTimeout(settleTimer);
        clearTimeout(switchEndTimer);
        delete navRow.ajMegaMenus;
      }
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target instanceof Node && event.target.contains(navRow)) destroy();
      }, { signal });

      navRow.ajMegaMenus = { show, hide, destroy, get current() { return current && current.panel.id; } };
    }

    const init = (root) => {
      if (root.id === 'HeaderNavRow') setup(root);
      root.querySelectorAll('#HeaderNavRow').forEach(setup);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
    else init(document);
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target instanceof Element) init(event.target);
    });
  })();

  // Variantele ascunse ale imaginilor din header (tema cealaltă: logo, luna, bara de anunț) sunt `lazy`, ca să nu
  // concureze cu bannerul la încărcare; după `load` le cerem, ca schimbarea temei să rămână instantanee.
  (() => {
    const warm = () => document.querySelectorAll('img[data-aj-warm]').forEach((image) => {
      image.loading = 'eager';
      image.removeAttribute('data-aj-warm');
    });
    if (document.readyState === 'complete') warm();
    else window.addEventListener('load', warm, { once: true });
    document.addEventListener('shopify:section:load', warm);
  })();
